import {
  DefaultDurationOption,
  OptionType,
  VisibilityOption,
} from "../../../../types/settings/enum";
import { Box, Flex, Text } from "@chakra-ui/react";
import {
  VisibilityDeepWorkIcon,
  VisibilityInvisibleIcon,
  VisibilityPublicIcon,
} from "../../../../icons";
import { capitalizeFirstLetter } from "../../../../utils/common/stringFormat/capitalizeFirstLetter";

interface ToggleSwitchProps {
  title: string;
  options: OptionType[];
  selectedOption: OptionType;
  onOptionChange: (option: OptionType) => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  title,
  options,
  selectedOption,
  onOptionChange,
}) => {
  const getIconComponent = (option: VisibilityOption, selected: VisibilityOption) => {
    if (option === VisibilityOption.PUBLIC) return VisibilityPublicIcon;
    if (option === VisibilityOption.INVISIBLE) return VisibilityInvisibleIcon;
    if (option === VisibilityOption.DEEPWORK) return VisibilityDeepWorkIcon;
  };

  const optionToView = (option: OptionType) => {
    switch (option) {
      case DefaultDurationOption.MIN15:
        return "15 mins";
      case DefaultDurationOption.MIN30:
        return "30 mins";
      case DefaultDurationOption.MIN60:
        return "1 hour";
      default:
        return option;
    }
  };

  return (
    <Flex
      py="10px"
      w="full"
      justify="space-between"
      align="center"
      position="relative"
      _after={{
        content: '""',
        position: "absolute",
        bottom: "-3px",
        left: 0,
        w: "full",
        h: "1px",
        bg: "rgba(255, 255, 255, 0.08)",
      }}
    >
      <Text
        textStyle="body1"
        color={"white"}
        userSelect={"none"}
      >
        {title}
      </Text>
      <Flex
        bg="rgba(0, 0, 0, 0.2)"
        borderRadius="7px"
        overflow="hidden"
        p={1}
        textStyle="body2"
      >
        {options.map((option) => {
          const isSelected = selectedOption === option;
          return (
            <Flex
              key={option.toString()}
              align="center"
              justify="center"
              px="10px"
              py="5px"
              borderRadius="5px"
              color={isSelected ? "white" : "#7c7d7d"}
              bg={isSelected ? "rgba(255, 255, 255, 0.15)" : "transparent"}
              transition="all 0.3s"
              cursor="pointer"
              onClick={() => onOptionChange(option)}
              _hover={{ color: "white" }}
              boxSizing="border-box"
            >
              <Flex
                gap={1}
                justifyContent={"center"}
                alignItems={"center"}
              >
                {title === "Visibility" &&
                  (() => {
                    const Icon = getIconComponent(
                      option as VisibilityOption,
                      selectedOption as VisibilityOption
                    );
                    return Icon ? <Icon /> : null;
                  })()}

                <Text
                  userSelect={"none"}
                  textStyle={"body2"}
                >
                  {capitalizeFirstLetter(optionToView(option))}
                </Text>
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    </Flex>
  );
};

export default ToggleSwitch;
